import LabelWithInput from "@components/input/LabelWithInput";
import styled from "@emotion/styled";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Radio } from "antd";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const Gender = (defaultValue: any) => {
  const { control, watch } = useFormContext();
  const { getGenderList } = useApiRequest();
  const { t } = useTranslation();
  const lang = window.localStorage.getItem("language");

  const { data: genderList } = useQuery({
    queryKey: ["genderList"],
    queryFn: () => getGenderList(),
  });

  return (
    <div>
      <LabelWithInput label="성별">
        <Controller
          name="gender"
          control={control}
          defaultValue={defaultValue}
          render={({ field }) => (
            <Radio.Group
              {...field}
              value={field.value}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
              style={{
                display: "flex",
                gap: "1.2rem",
                width: "100%",
                justifyContent: "space-between",
              }}>
              {genderList?.map((code: any) => (
                <StyledRadioButton
                  key={code.code}
                  value={code.code} // M, F, O 값 사용
                >
                  {/* name_en 값을 번역 키로 사용 */}
                  {lang === "en" ? code.name_en : code.name_ko}
                </StyledRadioButton>
              ))}
            </Radio.Group>
          )}
        />
      </LabelWithInput>
    </div>
  );
};

const StyledRadioButton = styled(Radio.Button)(({ theme }) => ({
  "&.ant-radio-button-wrapper": {
    fontSize: "1.6rem !important",

    height: "5.2rem",
    minWidth: "10.3rem",
    width: "100%",
    border: `1px solid ${theme.color.light_gray}`,
    color: theme.color.light_gray,
    borderRadius: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      borderColor: theme.color.mint,
      color: theme.color.black,
    },

    "&::before": {
      display: "none",
    },

    "&.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)":
      {
        background: theme.color.light_mint,
        boxShadow: "none",
        color: theme.color.black,
        borderColor: theme.color.mint,
      },
  },
}));
